<template lang="html">
	<div class="participant" v-show="pageReady">
		<div class="invite_people">
			<div class="header_mod">
				<p class="groupBookingNum"><span>{{buyTogether.view_num}}</span>人已领取课程</p>
				<p class="notice_mod" @click="getNotice">
					<img src="../../assets/image/course/notice.png" alt="">
					<span>拼单须知</span>
				</p>
			</div>

			<div class="course_particulars">
				<div class="course_details">
					<img :src="buyTogether.cover" alt="" class="cover">
					<div class="details_con">
						<p class="details_title">{{buyTogether.title}}</p>
						<p class="details_text">{{buyTogether.number}}人团</p>
						<div class="details_price">
							<p class="original_prices">
								<img :src="buyTogether.course_teacher.avatar" alt="">
								<span>{{buyTogether.course_teacher.username}}</span>
							</p>
							<p class="current_price">拼团价：￥{{buyTogether.price}}</p>
						</div>
					</div>
				</div>
			</div>

			<div class="time_title">
				<img src="../../assets/image/course/left_time_icon.png" alt="">
				<p>拼团剩余时间</p>
				<img src="../../assets/image/course/right_time_icon.png" alt="">
			</div>
			<div class="time_con">
				<p class="time_num">{{time_h}}</p>
				<p class="time_texe">时</p>
				<p class="time_num">{{time_m}}</p>
				<p class="time_texe">分</p>
				<p class="time_num">{{time_s}}</p>
				<p class="time_texe">秒</p>
			</div>

			<div class="joinPeople">
				<p class="joinTexe">
					邀请参团<span>{{buyTogether.number - buyTogether.remain_num}}</span>名，仅需继续邀请<span>{{buyTogether.remain_num}}</span>名
				</p>

				<div class="planMod">
					<div class="progressBar" :class="10 >= 100 ? 'nobg' : ''">
						<!-- 10为展示的进度，100为总的进度数量 -->
						<div :style="{width: `${(num / 100).toFixed(2) * 100}%` }" class="progressPlam">
							<span class="progressBtn">{{buyTogether.number - buyTogether.remain_num}}名</span>
						</div>
					</div>
				</div>

				<div v-for="(img, index) in joinUser" :key="index" class="multiple">
					<div class="joinTitle">
						<img src="../../assets/image/course/succeed.png" alt="" class="header">
						<p v-if="index == 0">团长</p>
						<p v-else>好友{{index}}</p>
					</div>
					<p class="joinPhone">{{img.phone}}</p>
					<p class="joinType">参团成功</p>
				</div>
			</div>

			<div class="invite_join">
				<div class="join_btn" @click="joinBtn" v-if="button == 0">0元参团</div>
				<div class="join_btn" @click="shareBtn" v-if="button == 1">你已参团点击邀请其他好友加速</div>
			</div>
		</div>

		<div class="add_teacher" v-show="buyTogether.qrcode != ''">
			<div class="wx_ma">
				<img :src="buyTogether.qrcode" alt="">
				<p>扫码关注公众号，第一时间获悉拼团结果</p>
			</div>
		</div>

		<div class="related_recommendation" v-if="buyTogetherList.length > 0">
			<div class="add_teacher_title">
				<div class="child_title">
					<img src="../../assets/image/course/vertical_icon.png" alt="" class="vertical">
					<p>推荐拼团课</p>
				</div>
				<p class="bayList" @click="bayList">更多> </p>
			</div>
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(a, index) in buyTogetherList" :key="index">
						<div class="promote_content">
							<img :src="a.cover" alt="" class="related_cover">
							<div class="related_details_con">
								<p class="details_title">{{a.title}}</p>
								<div class="details_money">
									<p>{{a.number}}人团</p>
									<p class="original_price"><s>￥{{a.orign_price}}</s><span>拼团价￥{{a.price}}</span></p>
								</div>
								<div class="teacherText">
									<div class="allTeacher">
										<div v-for="(b, index) in a.teacher" :key="index">
											<img :src="b.avatar" alt="" class="teacherImg">
										</div>
									</div>
									<p class="allTeacherName">
										<span class="teacherName" v-for="(c, index) in a.teacher" :key="index">{{c.username}}</span>
									</p>
								</div>
							</div>
						</div>
						<div class="purchase_btn" @click="getParticulars(a.id)">
							<p>发起拼团</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="wrapper_con">
			<div id="topVideoWrapper" class="topVideoWrapper" ref="topVideoWrapper" :style="{backgroundImage: 'url('+ videoPoster +')'}">
				<div class="playButton">
					<img src="@/assets/image/course/play.png" alt="">
				</div>
				<WxOpenTag ref="wxopentag" :extinfo="'class/detail?id=' + buyTogether.course_id" />
			</div>

			<div class="topTitleSection">
				<div class="mainTitle">
					{{courseData.title}}
				</div>
				<div class="topEvaluate">
					<img src="../../assets/image/course/star.png" alt="" class="star">
					<div class="comment">
						<div class="comment_con">
							<img src="../../assets/image/course/favor.png" alt="" class="icon">
							<p>12</p>
						</div>
						<div class="comment_con">
							<img src="../../assets/image/course/comment.png" alt="" class="icon">
							<p>12</p>
						</div>
					</div>
				</div>
				<div class="topUser">
					<img :src="courseData.avatar" alt="">
					<div class="username">{{courseData.username}}</div>
				</div>
			</div>

			<div class="course_con">
				<ul class="tab_tilte">
					<li class="tab_mod" @click="cur = 0" :class="{active:cur == 0}">
						详情
					</li>
					<li class="tab_mod" @click="cur = 1" :class="{active:cur == 1}">
						目录
					</li>
				</ul>
				<div class="tab_content">
					<div v-show="cur == 0">
						<div class="describe" v-html="courseData.about"></div>
					</div>
					<div v-show="cur == 1">
						<Catalogue :catalogueList="catalogueList" />
					</div>
				</div>
			</div>
		</div>

		<div class="down_btn">
			<div class="join_btn" @click="joinBtn" v-if="button == 0">0元参团</div>
			<div class="join_btn" @click="shareBtn" v-if="button == 1">邀请好友参团</div>
		</div>

		<CloseOver v-if="closeOverShow" :closeOverShow="closeOverShow" @parEvn="parEvn" />

		<Login ref="login" @login="loginCallback" />

		<!-- 提示 -->
		<div class="user_alert" v-show="userShow">
			<div class="user_alert_content">
				<p class="user_alert_title">很遗憾</p>
				<p class="user_alert_hint">当前手机号为老用户手机，请使用<br><span>新手机号重拼</span>或自行发团</p>
				<div class="user_alert_btn">
					<p class="launch_btn" @click="launchBtn">发起</p>
					<p class="afresh_btn" @click="afreshBtn">重拼</p>
				</div>
			</div>
		</div>

		<div class="userInformation" v-show="userInformationShow">
			<div class="userForm">
				<p>信息提交</p>
				<input type="" placeholder="请输入你的姓名" class="studentName" name="studentName" maxlength="20" v-model="studentName">
				<input type="" placeholder="请输入你的学校" class="school" name="school" maxlength="20" v-model="school">
				<input type="" placeholder="你的学院" class="college" name="college" maxlength="20" v-model="college">
				<input type="" placeholder="指导老师" class="teacher" name="teacher" maxlength="20" v-model="teacher">
				<div class="submitBtn" :class="{cover: getUserFormData}" @click="getSubmitBtn"> 提交 </div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper/swiper-bundle.min.js'
	import 'swiper/swiper-bundle.min.css'
	import utils from '@/utils/utils';
	import Storage from '@/utils/localStore'
	import WxShare from '@/utils/wxshare';
	import Catalogue from './com/Catalogue';
	import CloseOver from './com/CloseOver';
	import Login from '@/components/loginModule/Login'
	import WxOpenTag from '@/components/WxOpenTag'
	import {appId} from '@/utils/http'

	let userPro = {}

	export default {
		data() {
			return {
				pageReady: false,
				tid: this.$route.query.tid || '',
				tcode: this.$route.query.tcode || '',
				buyTogether: {
					course_teacher: {},
				},
				joinUser: [],
				buyTogetherList: {},
				courseData: {},
				time_h: '00',
				time_m: '00',
				time_s: '00',
				cur: 0,
				button: 0,
				closeOverShow: false,
				catalogueList: [],
				videoPoster: '',
				leadTime: '',
				num: 0,
				userShow: false,
				userType: 0,

				userInformationShow: false,
        studentName: '',
        school: '',
        college: '',
        teacher: '',
			}
		},

		computed: {
      getUserFormData() {
        return this.studentName && this.school && this.college && this.teacher
      }
    },

		components: {
			Catalogue,
			CloseOver,
			Login,
			WxOpenTag,
		},
		created() {
			this.checkUserPro()
		},
		mounted() {
			if (utils.browserChecker.isWx()) {
				this.$refs.wxopentag.register()
			}
			this.getSwiper();
		},
		methods: {
			checkUserPro() {
				let user = Storage.getItem('pink_user_pro')
				if (user) {
					userPro = user
					this.init()
					this.pageReady = true
				} else {
					let code = utils.getQuery('code', location.href)
					if (!code) {
						let open = encodeURIComponent(location.href)
						/*是否是在微信中打开在跳这个页面的时候这里会判断*/
						let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${open}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
						window.location.href = url
					} else {
						this.$http.get('/user/wxUserInfo', {
							params: {
								code: code,
								appid: appId,
								together_code: this.tcode,
								scene: '3',
							}
						}).then(res => {
							if (res.code >= 0) {
								userPro = res.data
								this.storeUserPro()
								this.init()
								/*用户授权之后 -> 拿到用户信息 才显示页面*/
								this.pageReady = true
							} else if (res.code == -888) {
								/*当code已经被使用过时，重新获取当前页面的code*/
								let curl = location.origin + location.pathname + location.hash
								let open = encodeURIComponent(curl)
								let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${open}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
								location.replace(url)
							} else {
								utils.showMessage('用户授权失败')
							}
						})
					}
				}
			},
			init() {
				this.getWx = new WxShare();
				this.getCourseInfo();
			},
			getCourseInfo() {
				this.$http.get('/course/buyTogetherDetail', {
					params: {
						id: this.tid,
						uid: userPro.uid || '',
						token: userPro.token || '',
						together_code: this.tcode,
					}
				}).then(res => {
					if (res.code >= 0) {
						document.title = '拼团详情'
						let data = res.data
						this.buyTogether = data.buy_together_info

						this.courseData = data.course_info;
						this.courseid = data.course_info.courseid;
						this.videoPoster = this.courseData.pic

						this.joinUserList = data.buy_together_info.join_user;

						if (this.joinUserList.length != 0) {
							this.joinUserList.forEach((user, index) => {
								this.joinUser[index] = user
							})
							this.joinUser = [...this.joinUser]
						}

						this.getBuyTogetherList();
						this.getNumber();
						this.getWx.share({
							title: this.buyTogether.title,
							desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
							link: window.location.href,
							imgUrl: this.buyTogether.cover,
						});
						this.getPeople();
						this.getChapter();
						/* 倒计时 */
						this.leadTime = this.buyTogether.deadline - parseInt(new Date().getTime() / 1000);
						this.getCountDown(this.leadTime);
					}
				})
			},

			getParticulars(tid) {
				this.$router.push({
					path: '/course',
					query: {
						tid: tid,
					}
				})
			},
			getNotice() {
				this.$router.replace({
					path: '/notice',
				})
			},
			// 进度条
			getNumber() {
				// 拼团总人数
				var a = this.buyTogether.number;
				// 已拼团人数
				var b = this.buyTogether.number - this.buyTogether.remain_num
				this.num = 100 / a * b;
			},
			getPeople() {
				if (this.buyTogether.join_status == 0) {
					this.button = 0;
					if (this.buyTogether.status == 2) {
						this.$router.replace({
							path: '/bayEnd',
							query: {
								tid: this.tid,
								tcode: this.tcode
							}
						})
					} else if (this.buyTogether.status == 1) {
						this.$router.replace({
							path: '/bayEnd',
							query: {
								tid: this.tid,
								tcode: this.tcode
							}
						})
					}
				} else if (this.buyTogether.join_status == 1) {
					this.button = 1;
					if (this.buyTogether.status == 2) {
						this.$router.replace({
							path: '/bayFailing',
							query: {
								tid: this.tid,
								tcode: this.tcode
							}
						})
					} else if (this.buyTogether.status == 1) {
						this.$router.replace({
							path: '/baySucceed',
							query: {
								tid: this.tid,
								tcode: this.tcode
							}
						})
					}
				} else if (this.buyTogether.join_status == 2) {
					this.button = 1;
					if (this.buyTogether.status == 2) {
						this.$router.replace({
							path: '/bayFailing',
							query: {
								tid: this.tid,
								tcode: this.tcode
							}
						})
					} else if (this.buyTogether.status == 1) {
						this.$router.replace({
							path: '/baySucceed',
							query: {
								tid: this.tid,
								tcode: this.tcode
							}
						})
					} else if (this.buyTogether.status == 0) {
						this.$router.replace({
							path: '/invite',
							query: {
								tid: this.tid,
								tcode: this.tcode
							}
						})
					}
				}
			},
			getChapter() {
				this.$http.get('/edu/listChapter', {
					params: {
						course_id: this.courseData.courseid,
					}
				}).then((res) => {
					if (res.code >= 0) {
						this.catalogueList = res.data;
					}
				})
			},
			storeUserPro() {
				Storage.setItem('pink_user_pro', userPro);
			},
			getCountDown(time) {
				this.countDown = setInterval(() => {
					time--;
					this.time_h = parseInt(time / 60 / 60);
					this.time_m = parseInt(time / 60 % 60);
					this.time_s = parseInt(time % 60);
					if (this.time_h < 10) {
						this.time_h = '0' + this.time_h;
					}
					if (this.time_m < 10) {
						this.time_m = '0' + this.time_m;
					}
					if (this.time_s < 10) {
						this.time_s = '0' + this.time_s;
					}

					if (time <= 0) {
						if (this.buyTogether.status == 2) {
							this.$router.push({
								path: '/bayFailing',
								query: {
									tid: this.tid,
									tcode: this.tcode
								}
							})
							clearInterval(this.countDown);
						} else if (this.buyTogether.status == 1) {
							this.$router.replace({
								path: '/baySucceed',
								query: {
									tid: this.tid,
									tcode: this.tcode
								}
							})
							clearInterval(this.countDown);
						}
					}
				}, 1000);
			},
			getBuyTogetherList() {
				this.$http.get('/course/buyTogetherList', {
					params: {
						id: this.tid,
						uid: userPro.uid || '',
						token: userPro.token || '',
					}
				}).then(res => {
					if (res.code >= 0) {
						this.buyTogetherList = res.data;
						this.$nextTick(function() {
							this.getSwiper();
						}, 0);
					}
				})
			},
			joinBtn() {
				if (this.userType) {
					if(this.buyTogether.is_previous_join_buy_together != 1){
						this.userInformationShow = true;
					} else {
						this.login()
					}
				} else {
					this.login()
				}
			},
			login() {
				this.$refs.login.show({
					openid: userPro.openid,
					togetherId: this.tid
				})
			},
			loginCallback(uinfo = {}) {
				Object.assign(userPro, uinfo)
				if (userPro.is_new == 1) {
					this.userType = 1;
					this.userShow = false;
					this.getCourseInfo();
					this.storeUserPro();
				} else {
					if(this.buyTogether.is_previous_join_buy_together != 1){
						this.userType = 1;
						this.getCourseInfo();
						this.storeUserPro();
					} else {
						this.userType = 0;
						this.userShow = true;
						// this.getCourseInfo();
						this.storeUserPro();
					}
				}
			},
			bayList() {
				this.$router.push({
					path: '/bayList',
				})
			},
			getSwiper() {
				new Swiper('.swiper-container', {
					slidesPerView: "auto",
					spaceBetween: 10,
					observer: true,
					observeParents: true,
				});
			},
			shareBtn() {
				this.closeOverShow = true;
			},
			parEvn() {
				this.closeOverShow = false;
			},
			
			// 发起按钮
			launchBtn(){
				this.$router.push({
					path: '/course',
					query: {
						tid: this.tid,
					}
				})
			},
			afreshBtn(){
				this.userShow = false;
				this.userType = 1;
			},
			
			// 提交用户信息
			getSubmitBtn() {
				this.$http.get('/course/saveTogetherUserInfo', {
          params: {
            uid: userPro.uid,
            token: userPro.token,
            buy_together_id: this.tid,
            school: this.school,
            college: this.college,
            student_name: this.studentName,
            adviser: this.teacher,
            reg_channel: 'buy_together',
          }
        }).then(res => {
          if (res.code >= 0) {
            this.userInformationShow = false;

						// 拼团
						this.$http.get('/course/joinTogetherBuy', {
							params: {
								id: this.tid,
								uid: userPro.uid || '',
								token: userPro.token || '',
								together_code: this.tcode,
							}
						}).then(res => {
							if (res.code >= 0) {
								this.getCourseInfo();
								this.button = 1;
							} else if (res.code == -50) {
								utils.showMessage('登录已过期，请重新登录')
								this.login()
							} else {
								if(this.userType){
									this.login()
								} else {
									this.userShow = true;
								}
							}
						})
          }
        })
      },

			// 回填用户数据
			// backfillUserIngo(){}
		},
	}
</script>

<style lang="css" scoped>
	.participant {
		box-sizing: border-box;
		width: 100%;
		background-color: #F7F8F8;
	}

	.header_mod {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 1.5rem;
		margin-top: 1rem;
	}

	.groupBookingNum {
		box-sizing: border-box;
		display: inline-block;
		background-color: #FEF9F0;
		font-size: 1rem;
		padding: .3rem .8rem;
		border-radius: 2rem;
	}

	.groupBookingNum span {
		font-size: 1.2rem;
		color: #E57701;
	}

	.notice_mod {
		display: flex;
		align-items: center;
	}

	.notice_mod img {
		width: 1.6rem;
		height: 1.6rem;
		margin-top: .1rem;
		margin-right: .2rem;
	}

	.notice_mod span {
		font-size: 1.2rem;
		color: #606972;
		border-bottom: .1rem solid #606972;
	}

	.invite_people {
		box-sizing: border-box;
		padding-bottom: 2rem;
		background-color: #FFFFFF;
	}

	/* 头部课程详情 */
	.course_particulars {
		box-sizing: border-box;
		padding: 0 1.5rem;
	}

	.course_details {
		margin-top: 1.4rem;
		box-sizing: border-box;
		display: flex;
	}

	.cover {
		width: 13.7rem;
		height: 8.6rem;
		object-fit: cover;
		border-radius: .5rem;
		flex-shrink: 0;
	}

	.details_con {
		margin-left: 1rem;
		width: 100%;
	}

	.details_title {
		height: 3.8rem;
		font-size: 1.4rem;
		font-weight: bolder;
		color: #1D2023;
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	.details_money {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 1.2rem;
		color: #808598;
	}

	.details_text {
		font-size: 1.2rem;
		color: #606972;
		margin-top: .45rem;
		margin-right: 2rem;
		text-align: end;
	}

	.details_price {
		display: flex;
		justify-content: space-between;
		margin-top: .85rem;
	}

	.original_prices {
		width: 12rem;
		font-size: 1.2rem;
		color: #808598;
		display: flex;
		align-items: center;
	}
	
	.original_prices img {
		height: 2rem;
		border-radius: 50%;
		margin-right: .4rem;
	}
	
	.original_price {
		font-size: 1.2rem;
		color: #808598;
		display: flex;
		align-items: center;
	}
	
	.original_price s{
		margin-right: .5rem;
	}
	
	.original_price span{
		color: #E6001F;
	}

	.teacherText {
		height: 2rem;
		display: flex;
		align-items: center;
	}

	.allTeacher {
		display: flex;
		padding-left: .5rem;
	}

	.teacherImg {
		margin-left: -.5rem;
	}

	.teacherImg {
		width: 2rem;
		height: 2rem;
		border-radius: 50%;
		object-fit: cover;
	}

	.allTeacherName {
		height: 2.4rem;
		line-height: 2.4rem;
		margin-top: -.6rem;
		overflow: hidden;
		-webkit-line-clamp: 1;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		word-wrap: break-word;
		word-break: break-word;
	}

	.teacherName {
		font-size: 1.2rem;
		color: #808598;
		margin-left: .4rem;
	}

	.current_price {
		font-size: 1.2rem;
		color: #E6001F;
	}


	.time_title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.8rem;
		margin-top: 3rem;
	}

	.time_title img {
		height: 1rem;
		margin: 0 1rem;
	}

	.time_con {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.6rem;
		margin-top: 1.4rem;
	}

	.time_num {
		width: 2.4rem;
		height: 2.4rem;
		line-height: 2.4rem;
		text-align: center;
		border-radius: .5rem;
		color: #FFFFFF;
		background-color: #E50202;
	}

	.time_texe {
		color: #E50101;
		margin: 0 .7rem;
	}

	.invite_text {
		margin-top: 3rem;
		text-align: center;
		font-size: 1.8rem;
		color: #1D2023;
	}

	.invite_text span {
		color: #E50101;
	}

	.user_header {
		margin-top: 1.4rem;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: hidden;
	}

	.img_show {
		display: flex;
		align-items: center;
	}

	.joinPeople {
		box-sizing: border-box;
		background-color: #F5F6F8;
		margin: 0 1.5rem;
		margin-top: 1rem;
		border-radius: 1rem;
		padding: 1.4rem 2rem;
	}

	.joinTexe {
		font-size: 1.6rem;
		color: #1D2023;
		font-weight: 600;
	}

	.joinTexe span {
		font-size: 2rem;
		color: #E6001F;
	}

	.joinTitle {
		width: 6.65rem;
		display: flex;
		align-items: center;
		font-size: 1.4rem;
		color: #606972;
	}

	.joinTitle img {
		width: 1.8rem;
		height: 1.8rem;
		margin-right: 1rem;
	}

	.joinPhone {
		font-size: 1.2rem;
		color: #1D2023;
	}

	.joinType {
		font-size: 1.2rem;
		color: #1D2023;
	}

	/* 进去条 */
	.planMod {
		box-sizing: border-box;
		padding: 1.5rem 0;
	}

	.progressBar {
		box-sizing: border-box;
		position: relative;
		width: 100%;
		height: .6rem;
		background: #E8EAEC;
		border-radius: 5rem;
	}

	.progressPlam {
		position: absolute;
		top: 0;
		left: 0;
		height: .6rem;
		border-radius: 5rem;
		background: linear-gradient(to right, #FBC0D5, #FF99F0);
		padding-right: 3.6rem;
		box-sizing: border-box;
	}

	.progressBtn {
		box-sizing: border-box;
		position: absolute;
		right: 0;
		top: -.75rem;
		z-index: 10;
		display: block;
		width: 3.6rem;
		height: 2rem;
		line-height: 2rem;
		text-align: center;
		border-radius: 1em;
		background: #F95241;
		font-size: 1.2rem;
		color: #FFFFFF;
	}

	.multiple {
		margin-top: 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.header {
		width: 4.8rem;
		height: 4.8rem;
		border-radius: 50%;
		object-fit: cover;
	}

	.link {
		height: .4rem;
		margin: 0 2.5rem;
	}

	.invite_join {
		margin-top: 2.8rem;
		display: flex;
		justify-content: center;
	}

	.join_btn {
		width: 32.5rem;
		height: 4.5rem;
		line-height: 4.5rem;
		text-align: center;
		font-size: 1.8rem;
		color: #FFFFFF;
		background-color: #E6001F;
		border-radius: 2.25rem;
	}

	/* 课程详情 */
	.wrapper_con {
		box-sizing: border-box;
		margin-top: 1rem;
	}

	.add_teacher {
		margin-top: 1rem;
		box-sizing: border-box;
		padding: 1.6rem 1.5rem;
		vertical-align: middle;
		background-color: #FFFFFF;
	}

	.wx_ma {
		display: flex;
		justify-content: center;
		flex-direction: column;
		text-align: center;
		margin-top: 1.4rem;
		color: #606972;
		font-size: 1.2rem;
	}

	.wx_ma img {
		height: 9rem;
		margin: 0 auto;
	}

	.topVideoWrapper {
		position: relative;
		padding-top: 19rem;
		padding-top: calc(100% / 1.44 - 50);
		background: #d8d8d8 no-repeat;
		background-size: cover;
		background-position: center;
	}

	.playButton {
		position: absolute;
		width: 5.5rem;
		height: 5.5rem;
		top: 50%;
		left: 50%;
		margin-left: -2.75rem;
		margin-top: -2.75rem;
	}

	.playButton>img {
		width: 5.5rem;
		height: 5.5rem;
		object-fit: contain;
	}

	.topTitleSection {
		padding: 2rem 1.5rem 1.5rem 1.5rem;
		color: #1d2023;
		background-color: #FFFFFF;
	}

	.mainTitle {
		font-size: 1.6rem;
		font-weight: bolder;
		color: #1d2023;
		margin: 0;
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	.topEvaluate {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 1rem;
		margin-top: 1.5rem;
	}

	.star {
		height: 1.3rem;
	}

	.comment {
		display: flex;
	}

	.comment_con {
		display: flex;
		margin-left: 2rem;
	}

	.icon {
		height: 1.7rem;
	}

	.topUser {
		display: flex;
		align-items: center;
		margin-top: 1rem;
	}

	.topUser img {
		width: 3rem;
		height: 3rem;
		object-fit: cover;
		border-radius: 1.5rem;
	}

	.username {
		margin-left: .8rem;
		font-size: 1.4rem;
		color: #3F454B;
	}

	/* 相关推荐 */
	.related_recommendation {
		box-sizing: border-box;
		margin-top: 1rem;
		background-color: #FFFFFF;
		overflow: hidden;
		padding: 1.4rem 0;
	}

	.add_teacher_title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 1.8rem;
		padding: 0 1.5rem;
	}

	.vertical {
		height: 1.8rem;
		margin-right: .6rem;
	}

	.bayList {
		font-size: 1rem;
		color: #606972;
	}

	.child_title {
		width: 12rem;
		display: flex;
		align-items: center;
	}

	.swiper-container {
		box-sizing: border-box;
		padding: 2rem;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.swiper-wrapper {
		display: flex;
		justify-content: flex-start;
	}

	.swiper-slide {
		box-sizing: border-box;
		width: 32rem;
		height: 15.8rem;
		background-color: #FFFFFF;
		border-radius: .8rem;
		box-shadow: 0 0 1rem rgba(0, 0, 0, 0.1);
		padding-top: .3rem;
	}

	.promote_content {
		box-sizing: content-box;
		margin-right: 1rem;
		padding: 1.2rem 0;
		display: flex;
	}

	.related_cover {
		width: 13.7rem;
		height: 8.4rem;
		object-fit: cover;
		border-radius: .5rem;
		margin-left: 1rem;
		flex-shrink: 0;
	}

	.related_details_con {
		margin-left: 1rem;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.purchase_btn {
		display: flex;
		justify-content: center;
	}

	.purchase_btn p {
		width: 18rem;
		height: 3.2rem;
		line-height: 3.2rem;
		text-align: center;
		font-size: 1.4rem;
		color: #FFFFFF;
		background: linear-gradient(to right, #FE405A, #E50101);
		border-radius: 1.6rem;
	}

	.course_con {
		margin-top: 1rem;
		background-color: #FFFFFF;
		box-sizing: border-box;
		padding: 0 1.5rem;
	}

	.tab_tilte {
		width: 100%;
		height: 4.4rem;
		display: flex;
		border-bottom: .1rem solid rgba(0, 0, 0, 0.07);
	}

	.tab_mod {
		position: relative;
		width: 50%;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		font-size: 1.6rem;
		font-weight: bolder;
		color: #1D2023;
		z-index: 2;
	}

	.active {
		color: #FF0225;
	}

	.active:after {
		content: '';
		position: absolute;
		top: 0;
		left: 50%;
		text-align: center;
		border-radius: 1.5px;
		width: 3.3rem;
		height: .2rem;
		margin-top: 4.1rem;
		margin-left: -1.6rem;
		background-color: #FF0225;
		border-radius: .6rem;
		z-index: 1;
	}

	.describe {
		box-sizing: border-box;
		padding: 2rem 0;
	}

	.describe>>>img {
		max-width: 100%;
	}

	/* 按钮 */
	.down_btn {
		box-sizing: border-box;
		width: 100%;
		background-color: rgba(0, 0, 0, 0.0);
		align-items: center;
		justify-content: center;
		display: flex;
		justify-content: center;
		padding: 1.5rem 2.5rem;
	}

	@media (min-width: 751px) {
		.down_btn {
			width: 750px;
			left: 50%;
			margin-left: -375px;
		}
	}

	.close_over {
		box-sizing: border-box;
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.6);
		width: 100%;
		height: 100%;
		padding: 0 1.5rem;
		z-index: 10;
	}

	.close_over img {
		width: 100%;
	}

	/* 限制用户弹框 */
	.user_alert {
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.6);
		width: 100%;
		height: 100%;
		z-index: 10;
	}
	
	.user_alert_content{
		box-sizing: border-box;
		padding: 2.2rem 1.8rem;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -10.15rem;
		margin-left: -15rem;
		width: 30rem;
		height: 20rem;
		background-color: #FFFFFF;
		border-radius: 1rem;
	}
	
	.user_alert_title{
		font-size: 1.8rem;
		color: #1D2023;
		font-weight: 600;
		text-align: center;
	}
	
	.user_alert_hint{
		text-align: center;
		font-size: 1.6rem;
		color: #1D2023;
		margin-top: 2rem;
	}
	
	.user_alert_hint span{
		color: #E6001F;
		font-weight: 600;
	}
	
	.user_alert_btn{
		display: flex;
		justify-content: center;
		margin-top: 2.2rem;
	}
	
	.launch_btn{
		width: 12rem;
		height: 4.4rem;
		line-height: 4.4rem;
		text-align: center;
		border-radius: 4.4rem;
		color: #3F454B;
		font-size: 1.6rem;
		background-color: #F1F0F6;
		margin: 0 .5rem;
	}
	
	.afresh_btn{
		width: 12rem;
		height: 4.4rem;
		line-height: 4.4rem;
		text-align: center;
		border-radius: 4.4rem;
		color: #FFFFFF;
		font-size: 1.6rem;
		background: linear-gradient(#FE405A, #E50101);
		margin: 0 .5rem;
	}

	.userInformation {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.60);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .userForm {
    box-sizing: border-box;
    width: 30rem;
    height: 37.75rem;
    padding: 0 1.3rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
  }

  .userForm p {
    text-align: center;
    margin-top: 2.45rem;
    margin-bottom: 1.05rem;
    font-size: 1.8rem;
    font-weight: 600;
  }

  input {
    box-sizing: border-box;
    padding: 1.5rem 0.5rem;
    border: none;
    outline: none;
    background-color: #F5F5F7;
    margin-top: 1.5rem;
  }

  .studentName,
  .school,
  .college,
  .teacher {
    width: 100%;
    height: 4.4rem;
    font-size: 1.3rem;
    border-radius: .8rem;
  }

  .studentName[name="studentName"]::-webkit-input-placeholder {
    color: #BDBDBD;
  }

  .school[name="school"]::-webkit-input-placeholder {
    color: #BDBDBD;
  }

  .college[name="college"]::-webkit-input-placeholder {
    color: #BDBDBD;
  }

  .teacher[name="teacher"]::-webkit-input-placeholder {
    color: #BDBDBD;
  }

  .submitBtn {
    width: 100%;
    height: 4.55rem;
    background: #FCD0CB;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4.55rem;
    margin-top: 2rem;
    font-size: 1.8rem;
    color: #FFFFFF;
  }

  .cover {
    background: linear-gradient(#FE405A 0%, #E50101 100%);
  }
</style>
